/**
 * @generated SignedSource<<458692483c2c2e0ea47a03fd324955ee>>
 * @relayHash 1f8968d814ecf9ca0dc936ee80d421ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e045e26a8668ba5a7a377f709fbc209c3901d0a44e48c18a533b066fcb360c56

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useUsersContentPermissionsNewUserHasRestrictionsQuery$variables = {
  accountIds: ReadonlyArray<string | null | undefined>;
  cloudId: string;
  permission: string;
  resourceId: string;
  resourceType: string;
};
export type useUsersContentPermissionsNewUserHasRestrictionsQuery$data = {
  readonly confluenceUsers: {
    readonly nodes: ReadonlyArray<{
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly confluence_usersHavePermission: {
    readonly usersHavePermissionList: ReadonlyArray<{
      readonly hasPermission: boolean;
      readonly principalId: string;
    } | null | undefined>;
  } | null | undefined;
};
export type useUsersContentPermissionsNewUserHasRestrictionsQuery = {
  response: useUsersContentPermissionsNewUserHasRestrictionsQuery$data;
  variables: useUsersContentPermissionsNewUserHasRestrictionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permission"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceType"
},
v5 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    {
      "kind": "Variable",
      "name": "permission",
      "variableName": "permission"
    },
    {
      "kind": "Variable",
      "name": "principalIds",
      "variableName": "accountIds"
    },
    {
      "kind": "Variable",
      "name": "resourceId",
      "variableName": "resourceId"
    },
    {
      "kind": "Variable",
      "name": "resourceType",
      "variableName": "resourceType"
    }
  ],
  "concreteType": "ConfluenceUsersHavePermissionList",
  "kind": "LinkedField",
  "name": "confluence_usersHavePermission",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceUserHasPermission",
      "kind": "LinkedField",
      "name": "usersHavePermissionList",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "principalId"
        },
        {
          "kind": "ScalarField",
          "name": "hasPermission"
        }
      ]
    }
  ]
},
v6 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
    "selections": [
      (v5/*: any*/),
      {
        "args": (v6/*: any*/),
        "concreteType": "PaginatedPersonList",
        "kind": "LinkedField",
        "name": "confluenceUsers",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
    "selections": [
      (v5/*: any*/),
      {
        "args": (v6/*: any*/),
        "concreteType": "PaginatedPersonList",
        "kind": "LinkedField",
        "name": "confluenceUsers",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1f8968d814ecf9ca0dc936ee80d421ff",
    "id": "e045e26a8668ba5a7a377f709fbc209c3901d0a44e48c18a533b066fcb360c56",
    "metadata": {},
    "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
    "operationKind": "query",
    "text": "query useUsersContentPermissionsNewUserHasRestrictionsQuery($cloudId:ID!,$accountIds:[String]!,$resourceId:ID!,$resourceType:String!,$permission:String!){confluence_usersHavePermission(cloudId:$cloudId,principalIds:$accountIds,resourceId:$resourceId,resourceType:$resourceType,permission:$permission){usersHavePermissionList{principalId,hasPermission}},confluenceUsers(accountIds:$accountIds){nodes{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}"
  }
};
})();

(node as any).hash = "574ff7b442e7a8af2643d4ece91556c9";

export default node;
